import { render, staticRenderFns } from "./QuoteFreightTemplateListPage.vue?vue&type=template&id=733c8a42&"
import script from "./QuoteFreightTemplateListPage.vue?vue&type=script&lang=ts&"
export * from "./QuoteFreightTemplateListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports